import {AfterViewInit, Component, OnChanges, OnDestroy, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {RolesComponent} from './RolesComponent';
import * as React from 'react';
import {SideNavService} from 'src/app/services/sidenav.service';
import * as ReactDOM from 'react-dom';

@Component({
  selector: 'app-my-component',
  template: `<section style="width: 100%; transition:0.55s; text-align: center" id="title"
          [ngClass]="isSideNavVisible()?'side-menu-padding':''">
          <div class="page-heading">
            Roles
          </div>
        </section>
        <div [id]="rootId" style="transition: 0.6s" [ngClass]="isSideNavVisible()?'side-menu-padding':''">
    </div>
    `,
  styleUrls: ['../privilages/react.css'],
  encapsulation: ViewEncapsulation.None,
})
export class RolesComponentWraper implements OnChanges, OnDestroy, AfterViewInit {

  constructor(private sideNavService: SideNavService) {
  }

  public rootId = "rootId"

  ngOnChanges(changes: SimpleChanges): void {
    this.render();
  }

  ngAfterViewInit() {
    this.render();
  }

  ngOnDestroy() {
  }

  isSideNavVisible() {
    return this.sideNavService.isSideNavVisible;
  }

  private render() {
    ReactDOM.render(React.createElement(RolesComponent), document.getElementById(this.rootId))
  }
}
